/**
 * @generated SignedSource<<5aa8520ad65c914c521bfd0894f5cf44>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ActivityFeedbackButton_activity$data = {
  readonly feedbacks: ReadonlyArray<{
    readonly id: string;
  }> | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"ActivityFeedbackList_activity">;
  readonly " $fragmentType": "ActivityFeedbackButton_activity";
};
export type ActivityFeedbackButton_activity$key = {
  readonly " $data"?: ActivityFeedbackButton_activity$data;
  readonly " $fragmentSpreads": FragmentRefs<"ActivityFeedbackButton_activity">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ActivityFeedbackButton_activity",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ActivityFeedbackList_activity"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ActivityFeedback",
      "kind": "LinkedField",
      "name": "feedbacks",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Activity",
  "abstractKey": null
};

(node as any).hash = "81d474b6c7dfdc9b60e501e85f546ac9";

export default node;
